import Section from "../../components/Section";
import { fetchDashboardAPI } from "../../api/dashboardApi";
import React, { createContext, useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import DashboardHeader from "./DashboardHeader";
import { LoaderCircle } from "lucide-react";
import { toast } from "../../components/ui/use-toast";
import { IoCloseCircle } from "react-icons/io5";

export const DashboardContext = createContext();

const Dashboard = () => {
  const { setIsDashboardLoading, setDashboards } = useOutletContext();
  const params = useParams();
  const { dashboardId } = params;
  const [isLoading, setIsLoading] = useState(true);
  const [dashboard, setDashboard] = useState({ label: "", sections: [] });
  const [error, setError] = useState("");

  useEffect(() => {
    fetchDashboardAPI({
      dashboardId,
      setIsLoading,
      setError,
      setData: setDashboard,
    });
  }, [dashboardId]);

  if (error) {
    toast({
      title: "Fetching Dashboard",
      variant: "destructive",
      description: error,
    });
  }

  return (
    <div
      className={`relative  ${
        isLoading || error ? "overflow-hidden" : "overflow-auto"
      }`}
    >
      {isLoading ? (
        <div className="flex h-screen w-full text-zinc-500 justify-center items-center">
          <LoaderCircle className="animate-spin" />
        </div>
      ) : error ? (
        <div className="flex justify-center items-center h-screen gap-1">
          <IoCloseCircle className="text-red-500 w-5 h-5" />
          {error}
        </div>
      ) : (
        <div className="p-2 px-4">
          <DashboardHeader
            setIsDashboardLoading={setIsDashboardLoading}
            setDashboards={setDashboards}
            setDashboard={setDashboard}
            dashboardId={dashboardId}
            dashboardLabel={dashboard.label}
          />
          <DashboardContext.Provider value={setDashboard}>
            <Section sections={dashboard.sections} dashboardId={dashboardId} />
          </DashboardContext.Provider>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
